import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ServicesService } from '../services.service';
import { Router } from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {passwordMatchValidator} from '../validators/passwordmatch.validator';
import swal from 'sweetalert2';
import * as $ from 'jquery';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

    isLoginError =  false;
    header       = 'l-header';
    navbar       = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    public login = {'name': '', 'password' : ''};
    public registeredPhotograper  = {'nameP': '', 'email' : '' , 'number' : '', 'msg' : ''};
    loginForm: FormGroup;
    registerUserForm: FormGroup;
    public result;
    registerSuccess = false;
    registerFailed  = false;
    registerError   = 'Email Id already exist';

    constructor(private _services: ServicesService, private router: Router) { }

    ngOnInit() {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.loginForm = new FormGroup({
          'name': new FormControl('', [Validators.required]),
          'password': new FormControl('', [Validators.required])
        });

        this.registerUserForm = new FormGroup({
            // tslint:disable-next-line
            name:  new FormControl('', [Validators.required]),
            email:  new FormControl('', [Validators.required, Validators.email]),
            phone:  new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10,10}$')]),
            password:  new FormControl('', [Validators.required]),
            checkboxControl:  new FormControl('', [Validators.requiredTrue]),
            password_confirmation:  new FormControl('', [Validators.required, passwordMatchValidator(('password'))]),
        });

        $('.tb-preloader-wave').fadeOut();
        $('#tb-preloader').delay(200).fadeOut('slow').remove();
    }

    loginUser() {
         this._services.checkLogin(this.loginForm.value).subscribe((data: any) => {
                // console.log(data);
             if (data.message == 'unverified') {
                 this.verifyUserAccount(data.email);
             }else {
                 localStorage.setItem('userToken', data.token);

                 this._services.getUserData(data).subscribe((userData: any) => {
                     const myJSON = JSON.stringify(userData.result);
                     // console.log(myJSON);
                     localStorage.setItem('userData', myJSON);
                     this.router.navigate(['online-photo-order']);
                     // $('body').hide();
                     // window.location.reload();
                 });
             }
                 // this.router.navigate([''], { queryParams: { token: data.token } });
             },
         (err: HttpErrorResponse) => {
                  this.isLoginError = true;
             }
         );
    }
    registerUser() {
        // console.log("this.registerUserForm.value==", this.registerUserForm.controls['phone'].errors.pattern);
        if(this.registerUserForm.value.name==''){
            swal({
                title: 'Please fill the name',
            });
            return;
        }
        if(this.registerUserForm.value.email==''){
            swal({
                title: 'Please fill the email',
            });
            return;
        }
        if(this.registerUserForm.controls['email'].errors!=null){
            if(this.registerUserForm.controls['email'].errors.email) {
                swal({
                    title: 'Please enter correct email',
                });
                return;
            }
        }
        if(this.registerUserForm.value.password==''){
            swal({
                title: 'Please fill the password',
            });
            return;
        }
        if(this.registerUserForm.value.password.length<6){
            swal({
                title: 'The password must be atleast 6 characters',
            });
            return;
        }
        if(this.registerUserForm.value.password_confirmation==''){
            swal({
                title: 'Please confirm the password',
            });
            return;
        }
        if(this.registerUserForm.controls['phone'].errors!=null){
            if(this.registerUserForm.controls['phone'].errors.pattern) {
                swal({
                    title: 'Please enter correct number',
                });
                return;
            }
        }
        if(this.registerUserForm.value.phone==''){
            swal({
                title: 'Please fill the phone number',
            });
            return;
        }
        if(this.registerUserForm.value.checkboxControl==''){
            swal({
                title: 'Please agree to terms and conditions.',
            });
            return;
        }
        // console.log("this.registerUserForm.value==",this.registerUserForm.value)
        // return;
        this._services.registerUser(this.registerUserForm.value).subscribe((data: any) => {
            if (data.status == 200) {
                this.registerSuccess = true;
                this.registerFailed = false;
                this.registerUserForm.reset();
            }else if(data.status == 403){
                this.registerError = data.message;
                this.registerFailed = true;
                this.registerFailed = true;
            }
            else {
                this.registerSuccess = false;
                this.registerFailed = true;
                this.registerError = 'Something went wrong';
            }
        },
        (err: HttpErrorResponse) => {
            // console.log(err.error.result.email);
            this.registerError = err.error.result.email;
            this.registerFailed = true;
            this.registerFailed = true;
        });
    }

    forgetPassword() {
        const that  = this;
        swal({
            title: 'Email',
            text: 'Please Enter Your Registered Email',
            input: 'email',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (email) => {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        if (email === '') {
                            swal.showValidationError(
                                'Please enter a valid email.'
                            );
                        }
                        resolve(

                        );
                    }, 2000);
                });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((email) => {
            that._services.forgetPassword({'email': email.value}).subscribe((data: any) => {
                    if (data.status === 200) {
                        swal({
                            type: 'success',
                            title: data.msg,
                        });
                    }else {
                        swal({
                            type: 'error',
                            title: data.msg,
                        });
                    }
                },
                (err: HttpErrorResponse) => {
                    this.isLoginError = true;
                }
            );
        });

    }
    verifyUserAccount(emailId){
        const that = this;
        swal({
            title: 'Your Account Is Not Verified!',
            html: 'Verification e-mail has been sent successfully. Please check your Inbox.',
            confirmButtonText : 'Send Verify Mail Again',
            showCancelButton : true,
            type : 'warning',
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                that._services.verifyUserAccount({email : emailId}).subscribe((response: any) => {
                    if (response.status = 200) {
                        swal({
                            type: 'success',
                            title: 'Success',
                            text: 'We have send verification mail on your registered email Id',
                        });
                    }
                }) ;

            }
        });
    }



}


// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/login/login.component.ts